import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { surveySchema } from '../models/survey.schema';
import { surveysListQuerySchema } from './list.schema';

export type SurveysListQuery = {
  pageSize?: number;
  templateUuid?: string;
  ordering?: string[];
};

export const list = (query: SurveysListQuery) => {
  return {
    endpoint: `/surveys`,
    method: 'GET',
    responseSchema: listResponse(surveySchema),
    query: { ...query, includeTotal: true },
    querySchema: surveysListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
